module.exports = __webpack_public_path__ + "static/media/media_wheel.71a74ac8.mp3";